// import React, { useEffect, useState } from "react";
// import { Col, Row } from "react-bootstrap";

// // img
// import g1 from "../../../../../Assets/images/g3.png";
// import DashboardRevenueGraph from "../../../Dashboard/revenuegraph";
// import ReactApexChart from "react-apexcharts";

// const RevenueReport = ({ bookingReport }) => {
//   const options = {
//     chart: {
//       id: "basic-bar",
//       height: 350,
//     },
//     xaxis: {
//       categories: bookingReport?.weeklyBookingGraphData?.map((i) => i?.date),
//       // categories: [
//       //   "January",
//       //   "February",
//       //   "March",
//       //   "April",
//       //   "May",
//       //   "June",
//       //   "July",
//       //   "August",
//       //   "September",
//       //   "October",
//       //   "November",
//       //   "December",
//       // ],
//     },
//     plotOptions: {
//       bar: {
//         borderRadius: 5,
//         borderRadiusApplication: "end",
//         columnWidth: "50%",
//       },
//     },
//     colors: ["#bf0020"],
//   };

//   const series = [
//     {
//       name: "Revenue",
//       data: bookingReport?.weeklyBookingGraphData?.map((i) => i?.totalRevenue),
//     },
//   ];

//   return (
//     <>
//       <Row className="justify-content-center">
//         <Col lg="12">
//           <div className="cardCstm p-3 rounded border">
//             <div className="cardHead m-0 pb-2">
//               <h6 className="m-0 fw-sbold themeBlue">No. of Booking</h6>
//             </div>
//             <div className="graph">
//               {/* <img src={g1} alt="" className="img-fluid" /> */}
//               <ReactApexChart
//                 options={options}
//                 series={series}
//                 type="bar"
//                 height={350}
//               />
//             </div>
//           </div>
//         </Col>
//       </Row>
//     </>
//   );
// };

// export default RevenueReport;

import React from "react";
import { Col, Row } from "react-bootstrap";
import ReactApexChart from "react-apexcharts";

const RevenueReport = ({ bookingReport }) => {
  // Provide default values in case bookingReport or weeklyBookingGraphData is undefined
  const graphData = bookingReport?.weeklyBookingGraphData || [];  
  console.log(bookingReport, "dasdasdjsakdkadbkas");

  const options = {
    chart: {
      id: "basic-bar",
      height: 350,
    },
    xaxis: {
      categories: graphData.map((i) => i?.date),
    },
    plotOptions: {
      bar: {
        borderRadius: 5,
        borderRadiusApplication: "end",
        columnWidth: "50%",
      },
    },
    colors: ["#bf0020"],
  };

  const series = [
    {
      name: "Revenue",
      data: graphData.map((i) => i?.totalRevenue),
    },
  ];

  return (
    <>
      <Row className="justify-content-center">
        <Col lg="12">
          <div className="cardCstm p-3 rounded border">
            <div className="cardHead m-0 pb-2">
              {/* <h6 className="m-0 fw-sbold themeBlue">No. of Booking</h6> */}
            </div>
            <div className="graph">
              <ReactApexChart
                options={options}
                series={series}
                type="bar"
                height={350}
              />
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default RevenueReport;
